var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 .75A.75.75 0 0 1 .75 0h16.5a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75V.75Zm1.5.75v15h15v-15h-15Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "accent",
    d: "M11.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-6.47-.53a.75.75 0 0 0-1.06 0l-3.5 3.5a.75.75 0 1 0 1.06 1.06L4.5 9.06l8.47 8.47a.75.75 0 1 0 1.06-1.06L10.56 13l.94-.94 4.47 4.47a.75.75 0 1 0 1.06-1.06l-5-5a.75.75 0 0 0-1.06 0L9.5 11.94 5.03 7.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAlt3);
export default __webpack_public_path__ + "static/media/image-alt-3.9f6cbe7eb1746e05ca6fb688d94f39fa.svg";
export { ForwardRef as ReactComponent };